import { NotFoundState } from "@rio-cloud/rio-uikit";
import { useMediaQuery } from "@mui/material";
import { useIntl } from "react-intl";

const EmptyTable = () => {
    const intl = useIntl();
    const isMobile = useMediaQuery("(max-width: 768px)");
    if (isMobile) {
        return (
            <div className="w-full flex justify-center items-center p-4">
                <NotFoundState
                    headline={intl.formatMessage({ id: "intl-msg:monitoring.emptyState.headline" })}
                    message={intl.formatMessage({ id: "intl-msg:monitoring.emptyState.message" })}
                    outerClassName="border-none w-full"
                />
            </div>
        );
    }
    return (
        <table className="margin-top-10 w-full">
            <tbody>
                <tr>
                    <td colSpan={5}>
                        <NotFoundState
                            headline={intl.formatMessage({ id: "intl-msg:monitoring.emptyState.headline" })}
                            message={intl.formatMessage({ id: "intl-msg:monitoring.emptyState.message" })}
                            outerClassName="border-none"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default EmptyTable;